import { useQuery } from '@tanstack/react-query';

import useApi from '@/hooks/useApi/useApi';
import { queryKeys } from '@/lib/queryKeys';
import { Interval, Project, Task } from '@/types/types';
import { API_URL } from '@/lib/apiUrl';

const useIntervals = (
  projectId: Project['id'] | null,
  resourceId: Interval['intervalable_id'],
  intervalableType: Interval['intervalable_type'],
  taskId?: Task['id']
) => {
  const { axiosInstance } = useApi();

  return useQuery<Interval[]>({
    queryKey: queryKeys.intervals.byResource({
      projectId,
      resourceId,
      intervalableType,
      taskId,
    }).queryKey,
    queryFn: async () => {
      const { data } = await axiosInstance.get<Interval[]>(
        `${API_URL}/api/v1/intervals`,
        {
          params: {
            resource_id: resourceId,
            project_id: projectId,
            intervalable_type: intervalableType,
            task_id: taskId,
          },
        }
      );
      return data;
    },
  });
};

export const useIntervalsByAssignment = (
  projectId: Task['project_id'],
  assignmentId: Interval['task_id']
) => {
  const { axiosInstance } = useApi();

  return useQuery<Interval[]>({
    queryKey: queryKeys.intervals.byAssignment(projectId || '', assignmentId).queryKey,
    queryFn: async () => {
      const { data } = await axiosInstance.get<Interval[]>(
        `${API_URL}/api/v1/intervals`,
        {
          params: {
            task_id: assignmentId,
            project_id: projectId,
          },
        }
      );
      return data;
    },
  });
};

export default useIntervals;
